module.exports = {
	macRegex: /^[0-9a-fA-F]{12}$/, //accepts upper and lower cases for APIs
	//Password policy: at least 12 characters with an uppercase, a lowercase, a digit and a special character
	passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{12,}$/,
	passwordMaxLength: 72, //bcrypt silently truncates anything beyond 72 bytes
	imSerialNumberRegex: /^(P[0-3]0(0[1-9]|10|11|12)[0-9][0-9]\d{5})$/, //IoTEmeter devices serial number

	empty: function(data)
	{
		if(typeof(data) == 'number' || typeof(data) == 'boolean')
		{ 
			return false; 
		}
		if(typeof(data) == 'undefined' || data === null)
		{
			return true; 
		}
		if(typeof(data.length) != 'undefined')
		{
			return data.length == 0;
		}
		var count = 0;
		for(var i in data)
		{
			if(data.hasOwnProperty(i))
				count ++;
		}
		return count == 0;
	},

	decimal2binary(decimal, bitsMinLength = 1) {
		let result = (decimal >>> 0).toString(2);

		if (!result || result.length < bitsMinLength)
			result = '0'.repeat(bitsMinLength - result.length) + result;

		return result;
	},

	binary2decimal(bin) {
		return parseInt(bin, 2);
	},

	dataValidator: function(type, options, value) {
		var isValid = false;
		switch(type) {
			case 'integer':
				if(value == parseInt(value)) {

					value = parseInt(value);

					var validMin = true, validMax = true, validStep = true;
					
					if(typeof(options.min) !== "undefined" && value < options.min)
						validMin = false;
					if(typeof(options.max) !== "undefined" && value > options.max)
						validMax = false;
					if(typeof(options.step) !== "undefined" && (value % options.step != 0))
						validStep = false;
					
					if(validMin && validMax && validStep)
						isValid = true;
				}
			break;
			
			case 'float':
				if(value == parseFloat(value)) {

					value = parseFloat(value);
					
					var validMin = true, validMax = true, validStep = true;
					
					if(typeof(options.min) !== "undefined" && value < options.min)
						validMin = false;
					if(typeof(options.max) !== "undefined" && value > options.max)
						validMax = false;
					if(typeof(options.step) !== "undefined" && (value % options.step != 0))
						validStep = false;
					
					if(validMin && validMax && validStep)
						isValid = true;
				}
			break;
			
			case 'boolean':
				if(typeof(value) === "boolean")
					isValid = true;
			break;
			
			case 'string':
				if(options.allowEmpty && this.empty(value)){
					isValid = true;
					break;
				}

				if(typeof(value) === "string") {
					var validMin = true, validMax = true;
					let strLen = value.length;
					
					if(typeof(options.min) !== "undefined" && strLen < options.min)
						validMin = false;
					if(typeof(options.max) !== "undefined" && strLen > options.max)
						validMax = false;
					
					if(validMin && validMax)
						isValid = true;
				}
			break;

			case 'hexString':
				if(options.allowEmpty && (value === null || value == undefined || value == '')) {
					isValid = true;
					break;
				}
				
				if(typeof(value) === "string") {
					value = value.trim().replace(/:/g, "");
					isValid = /^[a-fA-F0-9]{12}$/.test(value);
				}
			break;

			case 'hex':
				if(this.empty(value)){
					if(options.allowEmpty)
						isValid = true;
					break;
				}
				var regex = /\b[0-9A-Fa-f]+\b/gi;
				var validMin = true, validMax = true;
				let strLen = value.trim().length;
				
				if(typeof(options.value) !== "undefined" && strLen < options.min)
					validMin = false;
				if(typeof(options.max) !== "undefined" && strLen > options.max)
					validMax = false;
				
				if(validMin && validMax && regex.test(value.trim()))
					isValid = true;
			break;

			case 'password':
				if(options.allowEmpty && this.empty(value)){
					isValid = true;
					break;
				}
				if(typeof(value) === "string") {
					isValid = this.passwordRegex.test(value) && value.length <= this.passwordMaxLength;
				}
			break;
			case 'email':
				if(options.allowEmpty && this.empty(value)){
					isValid = true;
					break;
				}
				if(typeof(value) === "string") {
					isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim()) && value.length <= 255;
				}
			break;
			case 'serialNumber':
				let newValue = value.trim();
				if(options.allowEmpty && this.empty(newValue)){
					isValid = true;
					break;
				}
				if(typeof(value) === "string") {
					isValid = /^T(\S){2}(0[1-9]|1[0-2])\d{2}\d{5}$/.test(value) || this.imSerialNumberRegex.test(newValue);
				}
			break;

			case 'imSerialNumber':
				const imSerialNumber = value.trim();
				if (options.allowEmpty && this.empty(imSerialNumber)) {
					isValid = true;
					break;
				}
				if (typeof (imSerialNumber) === "string") {
					isValid = this.imSerialNumberRegex.test(imSerialNumber);
				}
				break;

			case 'arrayOf':
				if(options.allowEmpty && this.empty(value)){
					isValid = true;
					break;
				}
				let validArray = true;
				switch(options.subType) {
					case 'integers':
						for (const ele of value) {
							if(typeof ele != 'number') {
								validArray = false;
								break;
							}
						}
						
					break;
					case 'emails':
						for (const ele of value) {
							const email = ele.email;
							if(typeof(email) === "string") {
								validArray = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()) && email.length <= 255;
							} else {
								validArray = false;
								break;
							}
						}
						break;
				}
				isValid = validArray;
			break;

			case 'inArray':
				switch(options.subType) {
					case 'integer':
						if(value == parseInt(value)) {
							value = parseInt(value);
						}
					break;
				}
				if(options.values.indexOf(value) > -1)
					isValid = true;
			break;

			case 'notInArray':
				switch(options.subType) {
					case 'float':
						if(value == parseFloat(value)) {

							value = parseFloat(value);

							if(options.values.indexOf(value) == -1)
								isValid = true;
						}
					break;
				}
			break;

			case 'phone':
				if(options.allowEmpty && this.empty(value)){
					isValid = true;
					break;
				}
				isValid = /^(\+\d{1,2}\s*)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
			break;

			case 'time':
				if(typeof(value) === "string") {
					var patt = /^((0|1)[0-9]|2[0-4]):[0-5][0-9]$/;
					if(patt.test(value)) {
						var time = value.split(':');
						var timeInMints = parseInt(time[0]) * 60 + parseInt(time[1]);

						var validMin = true, validMax = true, validStep = true;
					
						if(typeof(options.min) !== "undefined") {
							var minTime = options.min.split(':');
							var minTimeInMints = parseInt(minTime[0]) * 60 + parseInt(minTime[1]);

								if(timeInMints < minTimeInMints)	
								validMin = false;
						}
						
						if(typeof(options.max) !== "undefined") {
							var maxTime = options.max.split(':');
							var maxTimeInMints = parseInt(maxTime[0]) * 60 + parseInt(maxTime[1]);

								if(timeInMints > maxTimeInMints)	
								validMin = false;
						}
						
						if(typeof(options.step) !== "undefined" && (timeInMints % options.step != 0))
							validStep = false;

						if(validMin && validMax && validStep)
							isValid = true;
					}
				}
			break;

			case 'daysMask':
				var days = [0, 1, 2, 3, 4, 5, 6];
				if(typeof(value) === "object") {
					var withinDays = true;
					value.forEach(function(ele) {
						if(withinDays && days.indexOf(ele) == -1) {
							withinDays = false;
						}
					});

					if(withinDays)
						isValid = true;
				}
			break;
			
			case 'dateRange':
				var validMin = true, validMax = true;
				
				var DateInSecs = new Date(value).getTime();

				if(typeof(options.min) !== "undefined" && DateInSecs < options.min.getTime())
					validMin = false;
				if(typeof(options.max) !== "undefined" && DateInSecs > options.max.getTime())
					validMax = false;
				
				if(validMin && validMax)
					isValid = true;
			break;
			
			case 'ipAddressRegex':
				let ipPatt = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
				if(options.allowEmpty && this.empty(value)){
					isValid = true;
					break;
				}
				if(ipPatt.test(value))
					isValid = true;
			break;

			case 'regex':
				let hwValue = String(value).trim();
				if(options.allowEmpty && this.empty(hwValue)){
					isValid = true;
					break;
				}
				if(options.patt && options.patt.test(hwValue))
					isValid = true;
				if(options.strPatt && new RegExp(options.strPatt).test(hwValue))
					isValid = true;
			break;

			case 'arraySubset':
				if(typeof(value) === "object") {
					var withinDays = true;
					value.forEach(function(ele) {
						if(withinDays && options.values.indexOf(ele) == -1) {
							withinDays = false;
						}
					});

					if(withinDays)
						isValid = true;
				}
			break;

			case 'notNull':
				if(typeof(value) === 'string') {
					var trimmedValue = value.trim();
					if(trimmedValue.length > 0)
						isValid = true;
				}
				else if(typeof(value) === 'number') {
					if(!isNaN(value))
						isValid = true;
				}
			break;

			case 'preventWhiteSpaces':
				if(options.allowEmpty && this.empty(value)) {
					isValid = true;
					break;
				}
				if(typeof(value) === 'string') {
					let trimmedValue = value.trim();
					if(value.length !== 0 && trimmedValue.length === 0) {
						isValid = false; 
					} else {
						isValid = true;
					}
				}
			break;

			case 'rtLogFreq':
				const rtLogFrequencyBin = this.decimal2binary(value, 8);
				const rt_log_frequency = this.binary2decimal(rtLogFrequencyBin.slice(1));

				if (value > 255 || rt_log_frequency > 127 || !rt_log_frequency)
					break;

				isValid = true;
				break;
		}

		return isValid;
	},

	publicMailDomainsList: [
		'gmail.com',
		'yahoo.com',
		'hotmail.com',
		'aol.com',
		'hotmail.co.uk',
		'hotmail.fr',
		'msn.com',
		'yahoo.fr',
		'wanadoo.fr',
		'orange.fr',
		'comcast.net',
		'yahoo.co.uk',
		'yahoo.com.br',
		'yahoo.co.in',
		'live.com',
		'rediffmail.com',
		'free.fr',
		'gmx.de',
		'web.de',
		'yandex.ru',
		'ymail.com',
		'libero.it',
		'outlook.com',
		'uol.com.br',
		'bol.com.br',
		'mail.ru',
		'cox.net',
		'hotmail.it',
		'sbcglobal.net',
		'sfr.fr',
		'live.fr',
		'verizon.net',
		'live.co.uk',
		'googlemail.com',
		'yahoo.es',
		'ig.com.br',
		'live.nl',
		'bigpond.com',
		'terra.com.br',
		'yahoo.it',
		'neuf.fr',
		'yahoo.de',
		'alice.it',
		'rocketmail.com',
		'att.net',
		'laposte.net',
		'facebook.com',
		'bellsouth.net',
		'yahoo.in',
		'hotmail.es',
		'charter.net',
		'yahoo.ca',
		'yahoo.com.au',
		'rambler.ru',
		'hotmail.de',
		'tiscali.it',
		'shaw.ca',
		'yahoo.co.jp',
		'sky.com',
		'earthlink.net',
		'optonline.net',
		'freenet.de',
		't-online.de',
		'aliceadsl.fr',
		'virgilio.it',
		'home.nl',
		'qq.com',
		'telenet.be',
		'me.com',
		'yahoo.com.ar',
		'tiscali.co.uk',
		'yahoo.com.mx',
		'voila.fr',
		'gmx.net',
		'mail.com',
		'planet.nl',
		'tin.it',
		'live.it',
		'ntlworld.com',
		'arcor.de',
		'yahoo.co.id',
		'frontiernet.net',
		'hetnet.nl',
		'live.com.au',
		'yahoo.com.sg',
		'zonnet.nl',
		'club-internet.fr',
		'juno.com',
		'optusnet.com.au',
		'blueyonder.co.uk',
		'bluewin.ch',
		'skynet.be',
		'sympatico.ca',
		'windstream.net',
		'mac.com',
		'centurytel.net',
		'chello.nl',
		'live.ca',
		'aim.com',
		'bigpond.net.au',
	],

	validateCurrentThresholds(t) {
		const chargeToIdle  = t.current_charge_to_idle;
		const idleToCharge  = t.current_idle_to_charge;
		const inuseToIdle   = t.current_inuse_to_idle;
		const idleToInuse   = t.current_idle_to_inuse;
		const chargeToInuse = t.current_charge_to_inuse;
		const inuseToCharge = t.current_inuse_to_charge;

		const invalidFields = [];
		const error = (field) => invalidFields.push({ field });

		if (chargeToIdle < 1 || chargeToIdle > idleToCharge)
			error('current_charge_to_idle');

		if (idleToCharge < chargeToIdle || idleToCharge > 30)
			error('current_idle_to_charge');

		if (inuseToIdle > -1 || inuseToIdle < idleToInuse)
			error('current_inuse_to_idle');

		if (idleToInuse < -30 || idleToInuse > inuseToIdle)
			error('current_idle_to_inuse');

		if (chargeToInuse < idleToInuse || chargeToInuse > chargeToIdle)
			error('current_charge_to_inuse');

		if (inuseToCharge < inuseToIdle || inuseToCharge > idleToCharge)
			error('current_inuse_to_charge');

		return invalidFields.length ? invalidFields : null;
	},

	// IoTEmeter power state transition thresholds.
	// The threshold a state is entered on must sit at or above the threshold that same state is left on, so no
	// single reading can satisfy both directions at once and leave the device flipping between two states.
	// Consume to Generate and Generate to Consume take part in no comparison: the firmware reads them as
	// independent values.
	// When you change these rules, change the matching rules in the frontend (client/src/app/home/site-dashboard/device/device.service.ts).
	imPowerThresholdOrderRules: [
		{ field: 'idle_to_consume_power',  atLeast: 'consume_to_idle_power' },
		{ field: 'idle_to_generate_power', atLeast: 'generate_to_idle_power' },
	],

	// The whole number rule applies whichever events type the device is on, the rest only on State Based,
	// so pass isStateBased false to check a Daily save.
	validateImPowerThresholds(t, options) {
		const isStateBased = (options || {}).isStateBased !== false;
		const invalidFields = [];
		const error = (field) => {
			if (!invalidFields.some(invalid => invalid.field == field))
				invalidFields.push({ field });
		};
		const toNumber = (value) => {
			if (value === null || value === undefined || value === '')
				return null;

			const number = Number(value);

			return Number.isFinite(number) ? number : null;
		};

		for (const field in t) {
			const value = toNumber(t[field]);

			if (value === null || !Number.isInteger(value) || (isStateBased && value < 1))
				error(field);
		}

		if (!isStateBased)
			return invalidFields.length ? invalidFields : null;

		const failedValueRule = invalidFields.map(invalid => invalid.field);

		for (const rule of this.imPowerThresholdOrderRules) {
			// A comparison needs two usable sides. When either side is already invalid on its own, that is the
			// specific thing to fix, and comparing against it would only drag its counterpart in with it.
			if (failedValueRule.includes(rule.field) || failedValueRule.includes(rule.atLeast))
				continue;

			const value = toNumber(t[rule.field]);
			const limit = toNumber(t[rule.atLeast]);

			// A side that was not submitted at all takes part in no comparison.
			if (value === null || limit === null || value >= limit)
				continue;

			error(rule.field);
			error(rule.atLeast);
		}

		return invalidFields.length ? invalidFields : null;
	}
};